import React, { useEffect, useState, useRef } from "react";
import { Link, useNavigate } from "react-router-dom";
import { Helmet } from "react-helmet";
import Header from "../components/Frontend/Header";
import Footer from "../components/Frontend/Footer";
import CoursesWeOffer from "../components/Frontend/coursesWeOffer";
import FameWall from "../components/Frontend/FameWall";
import FameWallNaati from "../components/Frontend/FameWallNaati";
import Testimonial from "../components/Frontend/Testimonial";
import VideoTuts from "../components/Frontend/VideoTuts";
import WhyLove from "../components/Frontend/WhyLove";
import CrackedCodeSlider from "../components/Frontend/Sliders/CrackedCodeSlider";
import ReactGA from "react-ga";
import ReactHtmlParser from "react-html-parser";
import ReactPixel from "react-facebook-pixel";
import API from "api.js";
import { setAlert } from "action/index.js";
import { store } from "store/index";
import Slider from "react-slick";
import "slick-carousel/slick/slick.css";
import "slick-carousel/slick/slick-theme.css";
import SimpleReactValidator from "simple-react-validator";
import PhoneInputField from "components/Inputs/PhoneInputField";
import { isValidPhoneNumber } from "libphonenumber-js/mobile";
import {
  Modal,
  Button,
  Container,
  Row,
  Col,
  Form,
  Alert,
  InputGroup,
} from "react-bootstrap";
import Frame1 from "../assets/images/public-pages/Frame1.svg";
import Frame2 from "../assets/images/public-pages/Frame2.svg";
import Frame3 from "../assets/images/public-pages/Frame3.svg";
import Frame4 from "../assets/images/public-pages/Frame4.svg";
import Frame5 from "../assets/images/public-pages/Frame5.svg";
import Frame6 from "../assets/images/public-pages/Frame6.svg";
import Frame7 from "../assets/images/public-pages/Frame7.svg";
import Frame8 from "../assets/images/public-pages/Frame8.svg";
import Frame9 from "../assets/images/public-pages/Frame9.svg";
import Frame10 from "../assets/images/public-pages/Frame10.svg";
import Frame11 from "../assets/images/public-pages/Frame11.svg";
import Frame12 from "../assets/images/public-pages/Frame12.svg";
import Frame13 from "../assets/images/public-pages/Frame13.svg";
import Frame14 from "../assets/images/public-pages/Frame14.svg";
import Frame15 from "../assets/images/public-pages/Frame15.svg";
import Frame16 from "../assets/images/public-pages/Frame16.svg";
import Frame17 from "../assets/images/public-pages/Frame17.svg";
import Frame18 from "../assets/images/public-pages/Frame18.svg";
import Frame19 from "../assets/images/public-pages/Frame19.svg";
import Report from "../assets/images/public-pages/report.svg";
import Flexible from "../assets/images/public-pages/flexible-icon.svg";
import CheckList from "../assets/images/public-pages/check-list.svg";
import Filter from "../assets/images/public-pages/filter.svg";
import Reward from "../assets/images/public-pages/reward.svg";
import Success from "../assets/images/public-pages/Success.svg";
import Experience from "../assets/images/public-pages/Experience.svg";
import Updates from "../assets/images/public-pages/Updates.svg";
import Instruction from "../assets/images/public-pages/Instruction.svg";
import Immigration from "../assets/images/public-pages/Immigration-home.png";
import HomeHeroSection from "components/PublicPagesReusable/HomeHeroSection";
import AiPower from "components/PublicPagesReusable/AiPowerSection";
import TestimonialSection from "components/PublicPagesReusable/TestimonialSection";
import SkillAreas from "components/PublicPagesReusable/SkillAreas";
import ReusableHomePageSlider from "./ReusableHomePageSlider";
// import OnlinePricingTable from "components/PublicPagesReusable/OnlinePricingTable";
import ContentImageSection from "components/PublicPagesReusable/ContentImageSection";
import FaqSection from "components/PublicPagesReusable/FaqSection";
import AppBannerCustom from "components/PublicPagesReusable/AppBannerCustom";
import YoutubeVideoPlayer from "components/Dashboard/YoutubeVideoPlayer";
import { Swiper, SwiperSlide } from "swiper/react";
import { FreeMode } from "swiper/modules";
import "swiper/css";
import ButtonComp from "components/PublicPagesReusable/ButtonComp";
import CtaBanner from "components/PublicPagesReusable/CtaBanner";

const Home = () => {
  const navigate = useNavigate();
  const [indexModal, setIndexModal] = useState(false);
  const [name, setName] = useState("");
  const [phone, setPhone] = useState("");
  const [email, setEmail] = useState("");
  const [center, setCenter] = useState("");
  const [process, setProcess] = useState(false);
  const [taskModal, setTaskModal] = useState(false);
  const [task_success_bag, setTaskSuccessBag] = useState("");
  const [task_error_bag, setTaskErrorBag] = useState("");
  const [task_name, setTaskName] = useState("");
  const [task_phone, setTaskPhone] = useState("");
  const [task_email, setTaskEmail] = useState("");
  const [task_institute, setTaskInstitute] = useState("");
  const [branches, setBranches] = useState([]);
  const [update, setUpdate] = useState(false);
  const [isDialCodeSelected, setIsDialCodeSelected] = useState(null);

  const validator = useRef(
    new SimpleReactValidator({
      validators: {
        nameMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Name is required",
        },
        emailMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Email is required",
        },
        emailValid: {
          rule: (val) => {
            if (!val) return false;
            const regex = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;
            return regex.test(val);
          },
          message: "Please enter a valid email address",
        },
        phoneMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Phone Number is required",
        },
        dialCodeRequired: {
          rule: () => false,
          message: "Please select a dial code",
        },
        phoneValid: {
          rule: (val) => {
            if (!val) return false;
            return isValidPhoneNumber(val);
          },
          required: true,
          message: "Please enter a valid phone number for the selected country",
        },
        centerMatch: {
          rule: (val) =>
            val !== null && val !== undefined && val.toString().trim() !== "",
          required: true,
          message: "Center is required",
        },
      },
    }),
  );

  const settings = {
    dots: false,
    arrows: false,
    infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    pauseOnHover: true,
    pauseOnFocus: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: true,
        },
      },
    ],
  };
  const Turorialvideos = {
    dots: false,
    arrows: true,
    infinite: true,
    speed: 500,
    // slidesToShow: 4,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: true,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 1200,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 767,
        settings: {
          slidesToShow: 2,
          dots: true,
          arrows: true,
        },
      },
      {
        breakpoint: 575,
        settings: {
          slidesToShow: 1,
          dots: true,
          arrows: true,
        },
      },
    ],
  };
  const CardsSlider = {
    dots: true,
    arrows: true,
    infinite: true,
    speed: 500,
    slidesToShow: 1,
    slidesToScroll: 1,
    autoplay: false,
    pauseOnHover: true,
    pauseOnFocus: true,
    autoplaySpeed: 2000,
  };

  const pteSlider = {
    dots: true,
    arrows: true,
    // infinite: true,
    speed: 500,
    slidesToShow: 6,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 5,
        },
      },
      {
        breakpoint: 768,
        settings: {
          slidesToShow: 4,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };
  const naatiSlider = {
    dots: true,
    arrows: true,
    //   infinite: true,
    speed: 500,
    slidesToShow: 4,
    slidesToScroll: 1,
    autoplay: false,
    autoplaySpeed: 2000,
    responsive: [
      {
        breakpoint: 992,
        settings: {
          slidesToShow: 3,
        },
      },
      {
        breakpoint: 576,
        settings: {
          slidesToShow: 2,
        },
      },
    ],
  };

  useEffect(() => {
    if (isDialCodeSelected == false) {
      validator.current.showMessageFor("Enter Phone Number");
    }
  }, [isDialCodeSelected]);

  useEffect(() => {
    if (!store.getState().token) {
      setTimeout(() => {
        setIndexModal(true);
      }, 1000);
    }

    ReactGA.initialize("UA-157984080-1");
    ReactGA.pageview(window.location.pathname + window.location.search);

    
    // ReactPixel.init("197333187452630");
    // ReactPixel.pageView();

    timerFunc();
    getBranches();
  }, []);

  const getBranches = async () => {
    try {
      const res = await API({
        url: "getAllBranches",
        method: "GET",
      });

      if (res.status === 200) {
        setBranches(res.data.branches);
      }
    } catch (err) {
      console.log(err);
    }
  };

  const timerFunc = () => {};

  const closeIndexModal = (event) => {
    event.preventDefault();
    setIndexModal(false);
  };

  const changeInput = (setter) => (e) => {
    setter(e.target.value);
  };

  const handlePhoneChange = (value) => {
    setPhone(value);
  };

  const postSubmit = async (e) => {
    e.preventDefault();

    if (!validator.current.allValid()) {
      validator.current.showMessages();
      setUpdate(!update);
      return;
    }

    setProcess(true);

    const bodyFormData = new FormData();
    bodyFormData.append("phone", phone);
    bodyFormData.append("name", name);
    bodyFormData.append("email", email);
    bodyFormData.append("center", center);

    let res = null;

    try {
      res = await API({
        method: "POST",
        url: "/submit-query",
        data: bodyFormData,
      });
    } catch (err) {
      setProcess(false);
      return;
    }

    if (res.status === 200) {
      navigate("/trial-class-thankyou", { state: { flag: true } });
      setIndexModal(false);
    } else if (res.response?.status === 422) {
      setProcess(false);

      setError(res.response);

      let str = "";
      Object.values(res.response.data.errors).forEach((val) => {
        str += val[0] + "\n";
      });

      setErrorBag(str);
    }
  };

  const post20taskRequest = async (e) => {
    e.preventDefault();

    if (!task_name || !task_phone || !task_email || !task_institute) {
      setTaskErrorBag("Please fill all fields!");
      return;
    }

    setTaskErrorBag("");

    const bodyFormData = new FormData();
    bodyFormData.set("name", task_name);
    bodyFormData.set("phone", task_phone);
    bodyFormData.set("email", task_email);
    bodyFormData.set("institute", task_institute);

    let res = null;

    try {
      res = await API({
        method: "POST",
        url: "/task-request-submit-data",
        data: bodyFormData,
      });
    } catch (err) {}

    if (res && res.status === 200) {
      setTaskSuccessBag("Request Submitted Successfully!");
      setTimeout(() => {
        window.location.reload();
      }, 1000);
    } else {
      setTaskErrorBag("Unable to submit request!");
    }
  };

  const showTaskModal = () => setTaskModal(true);

  const closeTaskModal = (event) => {
    event.preventDefault();
    setTaskModal(false);
  };

const sliderList = {
  settings: {
    slidesPerView: 3,
    spaceBetween: 20,
    breakpoints: {
      0: { slidesPerView: 1 },
      768: { slidesPerView: 2 },
      1024: { slidesPerView: 3 },
    },
  },

    items: [
      {
        id: 1,
        name: "Savy Aulakh",
        location: "Australia",
        description:
          "LA academy is the best school to choose for PTE. I have taken online classes from this, and I was very happy and I got my desired score to get admission in nursing. All the staff members are very helpful: Vishika mam, tammana mam, Shefali mam. Vishika mam has especially helped me by reviewing my mock test and giving me feedback on things I need to improve. Overall, tips and strategies also worked as well as practice material is great on the portal. Thank you all for helping me.",
        image:
          "/images/web-new-images/new-content-slider/SavyAulakh.svg",
      },
      {
        id: 2,
        name: "Ahmad Farooq Sethi",
        location: "Lahore, Pakistan",
        description:
          "I’m really thankful to LA ACADEMY for helping me achieve my goal. They provided regular feedback on my mock tests through WhatsApp and stayed in touch every day to check on my preparation. Their constant support and guidance made a big difference in my success. Highly recommended!",
        image:
          "/images/web-new-images/new-content-slider/ahmad-farooq-sethi.svg",
      },
      {
        id: 3,
        name: "Kavita Thavasegarasingam",
        location: "Kopay",
        description:
          "I’m so happy to share that I achieved my desired PTE score! 🎉 A big thank you to Language Academy Parramatta for their excellent coaching and continuous support. The tutors were very professional, friendly, and provided effective strategies that really helped me improve my skills. Thank you so much for all your guidance and support!🎊🎉🌟",
        image: "/images/web-new-images/new-content-slider/kavita-singham.svg",
      },
      {
        id: 4,
        name: "Priyanka Acha",
        location: "Hyderabad, India",
        description:
          "I recommend Language Academy to my friends. The way of teaching and handling students, answering their queries with patience. Everything is good. I got 90 in the second attempt. I was amazed by my results. Thank you Language Academy for giving me great support.",
        image: "/images/web-new-images/new-content-slider/Priyanka-acha.svg",
      },
      {
        id: 5,
        name: "Rehan Tasneem",
        location: "Hyderabad, India",
        description:
          "LA is the best platform Today I took the PTE exam today and got my desired score of 7, definitely I will recommend LA, everything will be easy, and every tutor was quite helpful specially Manan Wadhwa. in my initial day's  I wasn't sure to clear my exam but after joined LA I saw the hope light. It is a great platform. Thank you Language Academy And all respected Teachers.",
        image: "/images/web-new-images/new-content-slider/Rehan-tasneem.svg",
      },
      {
        id: 6,
        name: "Larii Romero López",
        location: "-",
        description:
          "I was able to increase my PTE score points, from 61 to 82 overall. I absolutely recommend it.",
        image:
          "/images/web-new-images/new-content-slider/Larii-Romero.svg",
      },
      {
        id: 7,
        name: "Jatin Patel",
        location: "Surat, Gujarat, India",
        description:
          "I’m so happy to share that I achieved my desired score in PTE with the help of LA Language Academy, Parramatta! 🎉 The tutors are super supportive, the strategies they teach are spot-on, and the practice materials really prepare you for the real exam. They kept me motivated and confident throughout the journey. Highly recommend this academy to anyone aiming for success in PTE or NAATI CCL.",
        image:
          "/images/web-new-images/new-content-slider/jatin-patel.svg",
      },
      {
        id: 8,
        name: "Parteek Kamboj",
        location: "Yamunanagar, India",
        description:
          "Achieved my desired score with Language Academy! Super helpful mentors, smart tips, and great motivation throughout. Truly the best for PTE.",
        image: "/images/web-new-images/new-content-slider/Parteek-Kamboj.svg",
      },
      {
        id: 9,
        name: "Zainab Ahmed",
        location: "-",
        description:
          "Grateful to LA-Language Academy for their incredible support in helping me score 8 in each section of the PTE. Special thanks to Varun Sir and the team for their guidance. I highly recommend LA to anyone working towards their PTE goals.",
        image: "/images/web-new-images/new-content-slider/Zainab-Ahmed.svg",
      },
      {
        id: 10,
        name: "Samuel Sandeep",
        location: "Sydney, Australia",
        description:
          "I had a great experience with Language Academy while preparing for my PTE exam. Their expert tutors provided the right guidance, personalized feedback, and effective strategies, which helped me achieve my target scores. The supportive environment and focused approach made a significant difference in my preparation. I highly recommend Language Academy to anyone looking to excel in PTE.",
        image: "/images/web-new-images/new-content-slider/Samuel-sandeep.svg",
      },
      {
        id: 11,
        name: "Tushar Singh",
        location: "Melbourne, VIC",
        description:
          "I wanted to take a moment to express my sincere gratitude for all the support and guidance you provided during my preparation for the PTE exam. Your dedication, personalized approach, and expertise played a crucial role in helping me achieve the score I desired. The resources, practice materials, and constant encouragement truly made a difference in my preparation journey. I am incredibly grateful for the positive learning environment and the invaluable lessons I have gained. Thanks to your help, I feel confident and accomplished in my achievement. Once again, thank you for everything. I will always be appreciative of your efforts in helping me succeed.",
        image: "/images/web-new-images/new-content-slider/TusharSingh.png",
      },
      {
        id: 12,
        name: "Zubair Zaibi",
        location: "Faisalabad",
        description:
          "I attempted 8 times for 7 each but never got my desired score. Then I joined the language academy and within two weeks I got my desired score. Definitely, recommended to everyone who struggle like me.",
        image: "/images/web-new-images/new-content-slider/Zubair-Zaibi.svg",
      },
      {
        id: 13,
        name: "John Gharti",
        location: "Sydney, NSW",
        description:
          "LA Language Academy in Parramatta Sydney offers professional staff, smooth learning stages, and modern equipment. Tutors provide valuable feedback for both early and advanced English development. Ideal for anyone preparing for English exams like PTE, IELTS, NAATI and TOEFL in Sydney. Highly recommend this academy for effective English learning and exam preparation!",
        image: "/images/web-new-images/new-content-slider/John-Gharti.svg",
      },
      {
        id: 14,
        name: "Sujoy Gupta Joy",
        location: "Dinajpur, Rājshāhi, Bangladesh",
        description:
          "LA - Language Academy is one of the best places for PTE preparation. The tutors are highly skilled and provide excellent guidance to help you achieve your desired score. Their advanced software offers results that closely match the actual test, ensuring a realistic practice experience.",
        image: "/images/web-new-images/new-content-slider/Sujoy-Gupta-Joy.svg",
      }
    ],
  };

  const preprationWorkTitle = () => {
    return (
      <h3 className="top-section-text mb-4 white FS40FW600">
        <span className="text-success FS40FW600">The 5 Stages </span>
        <br />
        To Test Success
      </h3>
    );
  };

  const preprationWorkCards = [
    {
      title: "Break the Belief",
      text: "Unlearn what's been holding you back and see the English exam for what it really is.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Belief.svg",
      badge: "Step 1",
      borderColor:'#FFFFFF3D' 
    },
    {
      title: "Decode Exam Structure",
      text: "Understand how the PTE, NAATI CCL & IELTS scoring systems prioritize certain patterns and responses.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Decode.svg",
      badge: "Step 2",
      borderColor:'#FFFFFF3D'
    },
    {
      title: "Template Mastery",
      text: "Apply high-precision frameworks designed specifically for algorithm recognition in language tests.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Template.svg",
      badge: "Step 3",
      borderColor:'#FFFFFF3D'
    },
    {
      title: "Practice the Algorithm",
      text: "Train with real-time AI feedback modelled on the latest scoring patterns.",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Algorithm.svg",
      badge: "Step 4",
      borderColor:'#FFFFFF3D'
    },
    {
      title: "Re-Code Confidence",
      text: "Boost performance by preparing systematically for English exams. Stay focused and practice regularly!",
      color: "#0286FF",
      img: "/images/web-new-images/emojis/Updated/Confidence.svg",
      badge: "Step 5",
      borderColor:'#FFFFFF3D'
    },
  ];

  const skillAreaTitle2 = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        How Our PTE Training<br/> Academy System<br/> Transforms<br/>
        <span className="text-success FS40FW600">Your Results </span>
        <br />
      </h3>
    );
  };
  const centerText = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        <span className="text-success FS40FW600">Our Exam Victors</span>
        <br />
        Students Who Conquered PTE, NAATI & IELTS
      </h3>
    );
  };
  const styleCards = [
    {
      title: "Assessment",
      text: "We analyze your current approach, identify your specific PTE, NAATI or IELTS scoring gaps, and design a personalized strategy targeting your weak areas.",
      color: "#141414",
      img: Report,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Realignment",
      text: "You'll learn exactly how the language test algorithm evaluates responses and which specific patterns trigger higher scores, regardless of your English level.",
      color: "#141414",
      img: CheckList,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Application",
      text: "Practice with our AI-powered PTE & IELTS platform that simulates the actual scoring engine, providing real-time feedback on what's working & what needs adjustment.",
      color: "#141414",
      img: Flexible,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Refinement",
      text: "Expert Australian trainers provide personalized guidance, helping you apply the right templates and techniques for your specific challenges.",
      color: "#141414",
      img: Filter,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Validation",
      text: "Take our precision-tuned mock tests for PTE, NAATI CCL & IELTS with scoring that mirrors the real exam, confirming you're ready to achieve your target result.",
      color: "#141414",
      img: Reward,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
  ];
  const images = [
    {
      src: Frame1,
      alt: "score-1",
    },
    {
      src: Frame2,
      alt: "score-2",
    },
    {
      src: Frame3,
      alt: "score-3",
    },
    {
      src: Frame4,
      alt: "score-4",
    },
    {
      src: Frame5,
      alt: "score-5",
    },
    {
      src: Frame6,
      alt: "score-6",
    },{
      src: Frame7,
      alt: "score-7",
    },
    {
      src: Frame8,
      alt: "score-8",
    },
    {
      src: Frame9,
      alt: "score-9",
    },
    {
      src: Frame10,
      alt: "score-10",
    },
    {
      src: Frame11,
      alt: "score-11",
    },
    {
      src: Frame12,
      alt: "score-12",
    },
    {
      src: Frame13,
      alt: "score-13",
    },
    {
      src: Frame14,
      alt: "score-14",
    },{
      src: Frame15,
      alt: "score-15",
    },
    {
      src: Frame16,
      alt: "score-16",
    },
    {
      src: Frame17,
      alt: "score-17",
    },
    {
      src: Frame18,
      alt: "score-18",
    },
    {
      src: Frame19,
      alt: "score-19",
    }
  ];
  const pricingData = {
    title: "<span class='main-title FS40FW600'>Three Ways To</span><br/> <span class='text-success FS40FW600'>Master The Exam</span>",
    // highlight: "Master The Exam",
    subtitle: "Choose the path that works best for your goals",
    plans: [
      {
        title: "Online Platform",
        price: 29,
        description: "All core features, enhanced with",
        features: [
          "AI-Powered Portal Access",
          "Complete Question Bank",
          "Scored Mock Tests",
          "Updated Templates",
          "Self-Paced Video Lessons",
        ],
        buttonText: "Select Your Plan",
        isPopular: false,
      },
      {
        title: "Online Coaching",
        price: 249,
        description: "Everything in the Online Platform package, PLUS:",
        features: [
          "Live Virtual Classes",
          "Personalized Feedback",
          "Direct Trainer Access",
          "Priority Support",
        ],
        buttonText: "Select Your Plan",
        isPopular: true,
      },
      {
        title: "Campus Coaching",
        price: 249,
        description: "Everything in the Online Coaching package, PLUS",
        features: [
          "In-Person Traning",
          "One-on-one Sessions",
          "Intensive Workshops",
          "Extend Support",
          "Exam Booking Assistance",
        ],
        buttonText: "Select Your Plan",
        isPopular: false,
      },
    ],
  };

  const contentSection = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        Score Once
        <br />
        <span className="text-success FS40FW600">Save Thousands</span>
        <br />
      </h3>
    );
  };

  const successRateText = () => {
    return (
      <h3 className="top-section-text FS40FW600">
        <span className="text-success FS40FW600">95% Success Rate </span>
        <br />
        Numbers Don’t Lie
      </h3>
    );
  };
  const styleSuccessCards = [
    {
      title: "95% Success Rate",
      text: "The vast majority of our students achieve their target scores within 2 attempts",
      color: "#141414",
      img: Success,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "8+ Years Experience",
      text: "Our methodologies have been refined through thousands of successful outcomes",
      color: "#141414",
      img: Experience,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Continuous Updates",
      text: "Our materials and strategies evolve in real-time with changes to the exams",
      color: "#141414",
      img: Updates,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
    {
      title: "Expert Instruction",
      text: "Every trainer has scored 90/90 multiple times and understands the system inside out",
      color: "#141414",
      img: Instruction,
      boxShadow:'0 10px 25px rgba(0,0,0,0.03)',
      borderColor:'rgba(0, 0, 0, 0.05)'
    },
  ];

  const videosData = [
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=jJ0KuIm3pTQ",
      thumbnail: "/images/web-new-images/HomePageImage/01.webp",
    },
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=DF9AYqQA0X4&t=2s",
      thumbnail: "/images/web-new-images/HomePageImage/03.webp",
    },
     {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=U8yBis5fGn0",
      thumbnail: "/images/web-new-images/HomePageImage/04.webp",
    },
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=t4oyY3EPYGQ",
      thumbnail: "/images/web-new-images/HomePageImage/05.webp",
    },
     
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=9qsflzo8mkc",
      thumbnail: "/images/web-new-images/HomePageImage/06.webp",
    },
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=DF9AYqQA0X4&t=2s",
      thumbnail: "/images/web-new-images/HomePageImage/03.webp",
    },
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=kqfUL8ITe_g",
      thumbnail: "/images/web-new-images/HomePageImage/02.webp",
    },
      // {
      //   url: "https://www.youtube.com/watch?v=3rRY96mbizY",type: "youtube",
      // },
      // {
      //   url: "https://www.youtube.com/watch?v=hCJiZ7vuYTU&pp=0gcJCdkKAYcqIYzv",type: "youtube",
      // },
      // {
      //   url: "https://www.youtube.com/watch?v=SNhUFzI7-_c&pp=0gcJCdkKAYcqIYzv",type: "youtube",
      // },
      // {
      //   url: "https://www.youtube.com/watch?v=dVuVnoVTbVI",type: "youtube",
      // },
      // {
      //   url: "https://www.youtube.com/watch?v=U8yBis5fGn0",type: "youtube",
      // },
      // {
      //   url: "https://www.youtube.com/watch?v=t4oyY3EPYGQ",type: "youtube",
      // },
  ];

  const faqQuestions = [
    {
      question:
        "How is our PTE Training Institute different from other PTE training centres?",
      answer:
        "While most PTE training academies focus solely on English skills, our PTE Training Centre has reverse-engineered the actual scoring algorithms behind these exams.",
    },
    {
      question:
        "I've already failed multiple times. Will this really work for me?",
      answer:
        "Absolutely. In fact, students who have failed multiple times often see the most dramatic improvements because they've been solving the wrong problem. Our system specifically addresses the hidden patterns and scoring priorities that traditional preparation misses.",
    },
    {
      question:
        "I already have templates from another program. Why are yours better?",
      answer:
        "Generic templates don't work reliably because they're not aligned with current algorithm preferences. Our templates are continuously updated based on real-time exam analysis and designed to trigger specific scoring patterns in the current version of the test. That's why students who switch to our templates often see immediate 10+ point improvements.",
    },
    {
      question:
        "I've tried AI scoring tools before and they didn't help. How is yours different?",
      answer:
        "Most AI scoring tools are trained on general English parameters—not on the actual exam algorithm. Our proprietary scoring engine was reverse-engineered from analyzing thousands of real exam results, and is calibrated weekly against the latest test versions. It doesn't just score your answers; it diagnoses exactly which algorithm triggers you're missing.",
    },
    {
      question:
        "What if I can't attend live sessions due to time zone differences?",
      answer:
        "We offer 24/7 training options with recorded sessions, flexible booking for 1-on-1 coaching across all time zones, and our AI platform is available anytime. We currently serve students in 58+ countries, with specific support teams for each major time zone region.",
    },
    {
      question:
        "I'm applying for a visa with a tight deadline. Is there an accelerated option?",
      answer:
        "Yes, our 7-day Accelerated Program is specifically designed for deadline-driven students. It includes daily intensive training focused exclusively on your required score targets, priority feedback, and emergency support. We've helped hundreds of students meet tight visa deadlines with targeted preparation.",
    },
    {
      question: "Do I need advanced English to benefit from your system?",
      answer:
        "No, that's the beauty of our approach. Students with intermediate English often outperform advanced speakers by understanding how to work with the algorithm rather than against it. Your existing English is likely sufficient; you just need to apply it correctly.",
    },
    {
      question: "How quickly can I expect to see results?",
      answer:
        "Most students see significant score improvements within 2-3 weeks of starting our program. For those with specific score requirements, we typically recommend 4-6 weeks of preparation to ensure consistent performance on test day.",
    },
    {
      question: "What if the test format changes?",
      answer:
        "That's one of our key advantages. We continuously monitor all exam updates and immediately adapt our materials and strategies. When the test changes, we're usually the first to update our approach, keeping you ahead of the curve.",
    },
  ];
 
  const videosLinks = [
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=jJ0KuIm3pTQ",
      thumbnail: "/images/web-new-images/HomePageImage/01.webp",
    },
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=kqfUL8ITe_g",
      thumbnail: "/images/web-new-images/HomePageImage/02.webp",
    },
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=DF9AYqQA0X4&t=2s",
      thumbnail: "/images/web-new-images/HomePageImage/03.webp",
    },
     {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=U8yBis5fGn0",
      thumbnail: "/images/web-new-images/HomePageImage/04.webp",
    },
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=t4oyY3EPYGQ",
      thumbnail: "/images/web-new-images/HomePageImage/05.webp",
    },
    {
      type: "youtube",
      url: "https://www.youtube.com/watch?v=9qsflzo8mkc",
      thumbnail: "/images/web-new-images/HomePageImage/06.webp",
    },
    // {
    //   type: "youtube",
    //   url: "https://youtube.com/shorts/n-0E3HSV9oI?feature=share",
    //   thumbnail: "/images/web-new-images/HomePageImage/02.png",
    // },
    // {
    //   type: "youtube",
    //   url: "https://youtube.com/shorts/mxwp5IU5w6I",
    //   thumbnail: "/images/web-new-images/HomePageImage/04.png",
    // },
    // {
    //   type: "youtube",
    //   url: "https://youtube.com/shorts/8fCfyNnMgGU?feature=share",
    //   thumbnail: "/images/web-new-images/HomePageImage/05.png",
    // },
    // {
    //   type: "instagram",
    //   url: "https://www.instagram.com/reel/DK86KWNJ0jX/?igsh=MnF3N3Qwb3R2OXB3",
    //   thumbnail: "/images/web-new-images/HomePageImage/09.png",
    // },
    // {
    //   type: "instagram",
    //   url: "https://www.instagram.com/reel/DUmyCNJDBCg/?igsh=MTRybjExbWhyejRmcA==",
    //   thumbnail:  "/images/web-new-images/HomePageImage/03.png",
    // },
    // {
    //   type: "instagram",
    //   url: "https://www.instagram.com/reel/DUUwfcnil94/?igsh=MTN6b3Z3a3Q0enAwaw==",
    //   thumbnail: "/images/web-new-images/HomePageImage/01.png",
    // },
    // {
    //   type: "instagram",
    //   url: "https://www.instagram.com/reel/DTeryEAEnBC/?igsh=MW45NW5kcm9icGl3cA==",
    //   thumbnail: "/images/web-new-images/HomePageImage/06.png",
    // },
    // {
    //   type: "instagram",
    //   url: "https://www.instagram.com/reel/DTPPDiSAfpg/?igsh=MXN6azRwN2EydDhtZA==",
    //   thumbnail: "/images/web-new-images/HomePageImage/08.png",
    // },
    // {
    //   type: "instagram",
    //   url: "https://www.instagram.com/reel/DSwVaoBAGFS/?igsh=MTRnajF4YWdzaHN2ZA==",
    //   thumbnail: "/images/web-new-images/HomePageImage/07.png",
    // },
    // {
    //   type: "instagram",
    //   url: "https://www.instagram.com/reel/DSmCSi_AUpk/?igsh=M2N0cDZmMTJnZWdo",
    //   thumbnail: "/images/web-new-images/HomePageImage/06.png",
    // },
    // {
    //   type: "instagram",
    //   url: "https://www.instagram.com/reel/DSUArZrDW8_/?igsh=MXJuaTZmcWQ4eGphYQ==",
    //   thumbnail: "/images/web-new-images/HomePageImage/10.png",
    // },
  ];

  return (
    <>
      <Helmet>
        <title>
          PTE, NAATI & IELTS Coaching Australia | LA Language Academy
        </title>
        <meta
          name="description"
          content="Master PTE, NAATI & IELTS with LA Language Academy. Our comprehensive PTE online courses, training classes, and preparation programs are designed for your success."
        />
        <meta name="robots" content="index, follow" />
        <link rel="canonical" href={`https://www.languageacademy.com.au/`} />
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:site" content="@languageacademy" />
        <meta
          name="twitter:title"
          content="PTE, NAATI & IELTS Coaching Australia | LA Language Academy"
        />
        <meta
          name="twitter:description"
          content="Master PTE, NAATI & IELTS with LA Language Academy. Our comprehensive PTE online courses, training classes, and preparation programs are designed for your success."
        />
        <meta
          name="twitter:image"
          content={`https://www.languageacademy.com.au/images/logol.png`}
        />
        <meta name="twitter:image:alt" content="LA Language Academy Logo" />
        <meta
          property="og:url"
          content={`https://www.languageacademy.com.au/`}
        />
        <meta property="og:type" content="website" />
        <meta
          property="og:title"
          content="PTE, NAATI & IELTS Coaching Australia | LA Language Academy"
        />
        <meta
          property="og:description"
          content="Master PTE, NAATI & IELTS with LA Language Academy. Our comprehensive PTE online courses, training classes, and preparation programs are designed for your success."
        />
        <meta
          property="og:image"
          content={`https://www.languageacademy.com.au/images/logol.png`}
        />
        <meta property="og:image:alt" content="LA Language Academy Logo" />
        <meta property="og:image:width" content="1200" />
        <meta property="og:image:height" content="630" />
      </Helmet>

      <Modal
        show={false}
        onHide={closeIndexModal}
        size="lg"
        dialogClassName="main-popup"
        id="anouncementPopup"
        centered
      >
        <div className="modal-content">
          <div className="modal-header" hidden="">
            <a
              onClick={(e) => closeIndexModal(e)}
              style={{ color: "#93c13e", opacity: "unset" }}
              href="#"
              className="close"
              aria-label="Close"
            >
              <span aria-hidden="true">
                <img
                  className="img-fluid"
                  src="/images/web-new-images/icons/close-icon2.svg"
                  alt="LA"
                />
              </span>
            </a>
          </div>

          <div className="modal-body p-0">
            <div className="form-content-outer m-0">
              <div className="form-content">
                <div className="main-popup-img form-img">
                  <img
                    className="img-fluid"
                    src="/images/web-new-images/hero_img-02.png"
                    alt="LA"
                  />
                </div>

                <div className="main-popup-content form-content-right">
                  <h4 className="popup-title">
                    Attend a FREE TRIAL CLASS for PTE, NAATI CCL or IELTS with
                    us.
                  </h4>

                  <p className="popup-sub-title">Submit Your Details Below</p>

                  <div className="pte-popup-form-start">
                    <form onSubmit={postSubmit}>
                      {/* NAME FIELD */}
                      <div className="col-md-12">
                        <div className="fieldOuter">
                          <label htmlFor="Name">Name*</label>

                          <div className="form-input-outer">
                            <input
                              id="Name"
                              className="form-input"
                              value={name}
                              name="name"
                              placeholder="Enter Name"
                              type="text"
                              onChange={(e) => {
                                const value = e.target.value;
                                if (/^[A-Za-z ]*$/.test(value)) {
                                  changeInput(setName(value));
                                }
                              }}
                              onPaste={(e) => {
                                if (
                                  /[^A-Za-z ]/.test(
                                    e.clipboardData.getData("text"),
                                  )
                                ) {
                                  e.preventDefault();
                                }
                              }}
                            />
                          </div>

                          {validator.current.message("name", name, "nameMatch")}

                          <span className="err name-error"></span>
                        </div>
                      </div>

                      {/* PHONE FIELD */}
                      <div className="col-md-12">
                        <div className="fieldOuter">
                          <label htmlFor="PhoneNumber">Phone Number*</label>

                          <PhoneInputField
                            value={phone}
                            changeEvent={handlePhoneChange}
                            onDialCodeStatusChange={(status) =>
                              setIsDialCodeSelected(status)
                            }
                            addClass="popup-class"
                          />
                          {phone === ""
                            ? validator.current.message(
                                "Enter Phone Number",
                                phone,
                                "phoneMatch",
                              )
                            : !isDialCodeSelected
                              ? validator.current.message(
                                  "Enter Phone Number",
                                  phone,
                                  "dialCodeRequired",
                                )
                              : validator.current.message(
                                  "Enter Phone Number",
                                  phone,
                                  "phoneValid",
                                )}

                          <span className="err phone-error"></span>
                        </div>
                      </div>

                      {/* EMAIL FIELD */}
                      <div className="col-md-12">
                        <div className="fieldOuter">
                          <label htmlFor="email">Email*</label>

                          <div className="form-input-outer">
                            <input
                              id="email"
                              className="form-input"
                              name="email"
                              placeholder="Enter Email"
                              type="email"
                              value={email}
                              onChange={changeInput(setEmail)}
                            />
                          </div>

                          {validator.current.message(
                            "email",
                            email,
                            "emailMatch|emailValid",
                          )}

                          <span className="err email-error"></span>
                        </div>
                      </div>

                      {/* CENTER DROPDOWN */}
                      <div className="col-md-12">
                        <div className="fieldOuter">
                          <label htmlFor="Center">Center*</label>

                          <div className="form-input-outer form-select-wrapper">
                            <select
                              id="Center"
                              className="form-input"
                              name="center"
                              value={center}
                              onChange={changeInput(setCenter)}
                              style={{ color: "#808080cc" }}
                            >
                              <option value="" disabled>
                                Select center
                              </option>
                              {branches.map((branch) => (
                                <React.Fragment key={branch.id}>
                                  {branch.branch_detail?.title &&
                                    <option value={branch.branch_detail.title}>
                                      {branch.branch_detail.title}
                                    </option>
                                  }
                                </React.Fragment>
                              ))}
                                <option value="Online">Online</option>
                            </select>
                          </div>

                          {validator.current.message(
                            "center",
                            center,
                            "centerMatch",
                          )}

                          <span className="err email-error"></span>
                        </div>
                      </div>

                      {/* SUBMIT BUTTON */}
                      <div className="col-md-12 row_before_pte_submit">
                        {!process && (
                          <button type="submit" className="primary-btn">
                            SUBMIT
                            <img
                              src="/images/web-new-images/right-arrow.svg"
                              alt="LA"
                            />
                          </button>
                        )}

                        {process && (
                          <button
                            className="btn btn-primary pte_popup_modal_submit"
                            disabled
                          >
                            Wait...
                          </button>
                        )}
                      </div>
                    </form>
                  </div>

                  <div
                    className="pte-modal-inputf-gap"
                    style={{ height: "10px" }}
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </Modal>

      {taskModal && (
        <Modal
          isOpen={taskModal}
          id="anouncementPopup"
          size="lg"
          className="taskpopup"
        >
          <ModalBody>
            <Container>
              <Row>
                <Col className="ml-auto mr-auto" lg="12" md="12">
                  <button
                    onClick={closeTaskModal}
                    type="button"
                    className="close"
                    data-dismiss="modal"
                  >
                    &times;
                  </button>
                  <div className="mobileIcon">
                    <img
                      src="/images/experienced-trainer.png"
                      alt="mobile-img"
                    />
                  </div>

                  <Form action="" className="form" method="">
                    <h3 className="header text-center">
                      Get our portal for your institute
                    </h3>

                    {task_success_bag && (
                      <Alert color="success">{task_success_bag}</Alert>
                    )}

                    {task_error_bag && (
                      <Alert color="warning">{task_error_bag}</Alert>
                    )}

                    <InputGroup>
                      <InputGroup.Text>
                        <i className="nc-icon nc-single-02" />
                      </InputGroup.Text>
                      <Input
                        placeholder="Name"
                        type="text"
                        name="task_name"
                        value={task_name}
                        onChange={changeInput}
                        autoComplete="off"
                      />
                    </InputGroup>

                    <InputGroup>
                      <InputGroup.Text>
                        <i className="nc-icon nc-mobile" />
                      </InputGroup.Text>
                      <Input
                        placeholder="Phone"
                        type="number"
                        name="task_phone"
                        value={task_phone}
                        onChange={changeInput}
                        autoComplete="off"
                      />
                    </InputGroup>

                    <InputGroup>
                      <InputGroup.Text>
                        <i className="nc-icon nc-email-85" />
                      </InputGroup.Text>
                      <Input
                        placeholder="Email"
                        type="text"
                        name="task_email"
                        value={task_email}
                        onChange={changeInput}
                        autoComplete="off"
                      />
                    </InputGroup>

                    <InputGroup>
                      <InputGroup.Text>
                        <i className="nc-icon nc-badge" />
                      </InputGroup.Text>
                      <Input
                        placeholder="Institute Name"
                        type="text"
                        name="task_institute"
                        value={task_institute}
                        onChange={changeInput}
                        autoComplete="off"
                      />
                    </InputGroup>

                    <br />

                    <Button
                      className="btn-round mb-3"
                      color="warning"
                      onClick={post20taskRequest}
                    >
                      Submit
                    </Button>
                  </Form>
                </Col>
              </Row>
            </Container>
          </ModalBody>
        </Modal>
      )}
      <section className="new-design">
        <Header />

        <HomeHeroSection
          videosURLObject={videosLinks}
        />
        <div className="trusted-section py-5 m-0">
          <div className="container">
            <div className="row align-items-center text-center text-lg-start m-0">
              {/* LEFT SIDE - FLAGS */}
              <div className="col-lg-6 mb-4 mb-lg-0">
                <h6 className="trusted-title to-unset-transform mb-4 text-center">
                  Trusted by <span className="FS20FW500 fw-700">50,000+</span> Students' Globally
                </h6>

                <div className="d-flex flex-wrap justify-content-center gap-3 row justify-content-center">
                  {[
                    "australia",
                    "brazil",
                    "canada",
                    "ivory-coast",
                    "south-africa",
                    "pakistan",
                    "india",
                    "indonesia",
                    "nepal",
                    "bangladesh",
                    "vietnam",
                    "china",
                  ].map((flag, index) => (
                    <div className="col-4 col-md-2 col-lg-2" key={index}>
                      <div className="flag-wrapper text-center">
                        <img
                          src={`/images/web-new-images/flages/${flag}.png`}
                          alt={flag}
                        />
                      </div>
                    </div>
                  ))}
                </div>
              </div>

              {/* Divider (Desktop only) */}
              <div className="col-lg-1 d-none d-lg-flex justify-content-center">
                <div className="vertical-divider"></div>
              </div>

              {/* RIGHT SIDE - MEDIA LOGOS */}
              <div className="col-lg-5">
                <h6 className="trusted-title to-unset-transform mb-4 text-center">
                  Featured in Australian and International Media
                </h6>

                <div className="d-flex flex-wrap align-items-center row justify-content-center gap-4">
                  <div className="col-5">
                    <img
                      src="/images/web-new-images/logos/logo-11.png"
                      className="media-logo"
                    />
                  </div>
                  <div className="col-5">
                    <img
                      src="/images/web-new-images/logos/logo-09.png"
                      className="media-logo"
                    />
                  </div>
                  <div className="col-5">
                    <img
                      src="/images/web-new-images/logos/logo-10.png"
                      className="media-logo"
                    />
                  </div>
                  
                </div>
              </div>
            </div>
          </div>
        </div>

        <div className="custom-container success-section py-5">
          <div className="align-items-center justify-content-between row">
            {/* LEFT CONTENT */}
            <div className="col-lg-6 mb-4 mb-lg-0">
              <h3 className="hero-title FS40FW600">
                The Hidden Reason Most
                <br />
                <span className="text-success">PTE, NAATI & IELTS</span>{" "}
                Test-<br/>Takers Keep Failing
              </h3>

              <div className="quote-box FS18FW400 mt-3">
                It’s not just about fluency. It’s about strategy. <span className="plus-sans fw-700 FS18FW400">50,000+ students'</span><br/>
                worldwide rely on our algorithm-aware preparation
                methods.
              </div>

              <p className="mt-3 FS17FW500">
                You've studied for months. Your English language skills are
                strong. Friends say you speak well. Yet when the results arrive,
                you've missed your required score. Again. It's not your fault.
              </p>

              <p className="FS17FW500">
                These English proficiency exams punish even fluent speakers who
                don't understand the hidden scoring system behind the test.
              </p>

              {/* <button className="primary-btn mt-3" onClick={() => navigate("/auth/register")}>
                Start Free PTE Practice{" "}
                <img
                  src="/images/web-new-images/new-dark-arrow.svg"
                  alt="Register Now"
                />
              </button> */}
              <ButtonComp link={"/auth/register"} btnText={"Start Free PTE Practice"} img="/images/web-new-images/new-dark-arrow.svg"/>
            </div>

            {/* RIGHT IMAGE SECTION */}
            <div className="col-lg-6">
              <img
                src="/images/web-new-images/HomePageImage/homePage-section.webp"
                alt="mobile1"
              />
            </div>
          </div>
        </div>

        <StatsSection
          stats={[
            {
              icon: "/images/web-new-images/HomePageImage/hover1.png",
              value: "50,000<span class='symbol-text-success'>+</span>",
              label: "Students' Enrolled",
              color: "#5856D629",
              hoverImg: "/images/web-new-images/HomePageImage/hover1.png",
            },
            {
              icon: "/images/web-new-images/HomePageImage/hover2.png",
              value: "10<span class='symbol-text-success'>+</span>",
              label: "Learning Centers",
              color: "#FF2D5529",
              hoverImg: "/images/web-new-images/HomePageImage/hover2.png",
            },
            {
              icon: "/images/web-new-images/HomePageImage/hover3.png",
              value: "95<span class='symbol-text-success'>%</span>",
              label: "Success Rate",
              color: "#34C75929",
              hoverImg: "/images/web-new-images/HomePageImage/hover3.png",
            },
            {
              icon: "/images/web-new-images/HomePageImage/hover4.png",
              value: "8<span class='symbol-text-success'>+</span>",
              label: "Years Experience",
              color: "#D7780029",
              hoverImg: "/images/web-new-images/HomePageImage/hover4.png",
            },
          ]}
        />
        <AiPower btnText={"Start Free PTE Practice"} img="/images/web-new-images/new-dark-arrow.svg"/>
        <TestimonialSection
          title={`<span class="hero-title FS40FW600 text-center mb-0">They Cracked the Code <br/><span class="green-text">(And You Can Too)</span></span>`}
          showBtn={false}
          sliderList={sliderList}
        />
        <CourseSection
          courses={[
            {
              mainTitle: "PTE Training Centre",
              subTitle: "Courses We Offer",
              tabTitle: "PTE Academic Mastery",
              title: "PTE Academic Mastery",
              description:
                "Our flagship program reveals the hidden scoring mechanics behind all 22+ PTE question types. Using our proprietary AI system and proven templates, students' consistently achieve superior scores, often on their very next attempt.",
              ctaText: "Explore PTE Academic",
              ctaLink: "/auth/register",
              icon: "/images/web-new-images/HomePageImage/TrainingCenterIcon.png",
              image: "/images/web-new-images/NaatiAppPage.png",
            },
            {
              mainTitle: "PTE Training Centre",
              subTitle: "Courses We Offer",
              tabTitle: "NAATI CCL Decoder",
              title: "NAATI CCL Decoder",
              description:
                "Master the specific dialogue structure, vocabulary patterns, and error analysis techniques that the NAATI CCL scoring system rewards. Our specialized approach has helped thousands secure the crucial 5 points needed for migration.",
              ctaText: "Explore NAATI CCL",
              ctaLink: import.meta.env.VITE_NAATI_URL,
              icon: "/images/web-new-images/HomePageImage/TrainingCenterIcon.png",
              image: "/images/web-new-images/Training-centre.webp",
            },
            {
              mainTitle: "PTE Training Centre",
              subTitle: "Courses We Offer",
              tabTitle: "IELTS Breakthrough",
              title: "IELTS Breakthrough",
              description:
                "Our system-focused approach to IELTS identifies the specific patterns human examiners are trained to reward. Through targeted practice and strategic technique application, we've helped students achieve Band 7+ scores consistently.",
              ctaText: "See IELTS Courses",
              ctaLink: "/ielts-coaching-parramatta",
              icon: "/images/web-new-images/HomePageImage/TrainingCenterIcon.png",
              image: "/images/web-new-images/IELTS-Breakthrough.webp",
            },
          ]}
        />
        <SkillAreas
          skillAreaTitle={preprationWorkTitle}
          skillSubtitle="<span>Unlike traditional English coaching, our approach targets the exact mechanics behind<br/> PTE, NAATI CCL, and IELTS scoring systems.<br/><br/>
          We've reverse -engineered these exams through 8+ years of intensive research and over<br/> 50,000 student successes to create a methodology that delivers predictable results:</span>"
          lifestyleCards={preprationWorkCards}
          MiddleInfoSection={["Each stage has been carefully designed to convert your existing English abilities into the exact formats the Australian visa language testing systems reward."]}
          btnText2="Create Your Account"
          img="/images/web-new-images/new-dark-arrow.svg"
          sliders={4.2}
        />
        
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={skillAreaTitle2}
          lifestyleCards={styleCards}
          btnText={"Register Now"}
          skillSubtitle={
            "Our approach isn't just different, it's built on a fundamental insight most test-<br/>takers preparing for Australian visa requirements never discover at traditional<br/> PTE training centres."
          }
          img="/images/web-new-images/new-dark-arrow.svg"
          sliders={3.5}
        />
        <section className="results-section py-0 py-lg-5">
          <div className="custom-container">
            {/* Top Section */}
            <div className="row align-items-center mb-5 justify-content-between">
              {/* Left */}
              <div className="col-lg-5">
                <h3 className="text-success FS40FW600 mb-0">The Results</h3>
                <h3 className="top-section-text FS40FW600 mb-3">
                  You Can Expect
                </h3>

                <div className="p-3 rounded academy-highlight-box d-inline-block">
                  <p className="mb-0 plus-sans FS15FW400">
                    Our structured 4-week program delivers measurable progress
                    through precisely targeted practice, not endless generic
                    exercises.
                  </p>
                </div>
              </div>

              {/* Right */}
              <div className="col-lg-5 text-start mt-4 mt-lg-0">
                <p className="text-muted FS18FW400 fw-500 mb-3">
                  Our students consistently achieve specific, measurable results
                  that traditional preparation never delivered
                </p>

                {/* <button className="primary-btn" onClick={() => window.location.href = '/auth/register'}>
                  Join For Free{" "}
                  <img
                    src={`/images/web-new-images/right-arrow.svg`}
                    alt="Register Now"
                  />
                </button> */}
                <ButtonComp link={"/auth/register"} btnText={"Join For Free"} img="/images/web-new-images/new-dark-arrow.svg"/>
              </div>
            </div>

            {/* Bottom Section */}
            <div className="row g-4">
              {/* Left Image Card */}
              <div className="col-lg-4">
                <div className="plus-sans">
                  {/* <img
                  src="/images/web-new-images/HomePageImage/expectThumbnail.png"
                  alt="student"
                  className="img-fluid rounded-4 mb-3"
                /> */}
                  <video
                    autoPlay
                    playsInline
                    loop
                    muted
                    preload="metadata"
                    className="img-fluid video-custom rounded-4 mb-3"
                  >
                    <source src="/images/web-new-images/HomePageImage/i-want-to-extend-the-video.mp4" type="video/mp4"></source>
                  </video>

                  <h5 className="FS24FW500 fw-700">
                    79.4% Achieve Target Score<br/> In One Attempt
                  </h5>

                  <p className="FS16FW500 fw-400" style={{color:'#383838'}}>
                    Data from 12,843 previous students shows over 79% hit their
                    exact required score on their very next attempt after
                    joining our program.
                  </p>
                </div>
              </div>

              {/* Right Content */}
              <div className="col-lg-8 plus-sans">
                {/* Top Highlight Card */}
                <div
                  className="p-4 highlight-card d-flex justify-content-between align-items-start mb-4 flex-column-reverse flex-lg-row"
                  style={{ color: "black" }}
                >
                  <div>
                    <h5 className="FS22 fw-700 mb-2">
                      94.6% Success Rate For “Stuck” Students
                    </h5>
                    <p className="FS16FW500 fw-400 mb-0" style={{color:'#383838'}}>
                      Of students who failed 3+ times, 94.6% reached their
                      target score within 2 attempts using our algorithm.
                    </p>
                  </div>

                  <div className="icon-circle justify-content-start">
                    <img
                      src="/images/web-new-images/HomePageImage/success.svg"
                      alt="icon"
                    />
                  </div>
                </div>

                {/* Bottom Cards */}
                <div className="row g-4">
                  {/* Card 1 */}
                  <div className="col-md-6">
                    <div
                      className="p-4 info-card h-100"
                      style={{ background: "#E3E6FB" }}
                    >
                      <div className="icon-circle mb-3 justify-content-start">
                        <img
                          src="/images/web-new-images/HomePageImage/improvement.svg"
                          alt="icon"
                        />
                      </div>

                      <h6 className="FS22 fw-700 to-unset-transform">
                        Average 17–Point<br/> Improvement In 21 Days
                      </h6>

                      <p className="FS16FW500 fw-400 mb-0" style={{color:'#383838'}}>
                        Students who previously scored 65–70 in PTE typically
                        reach 82–87 within just 3 weeks of system-focused
                        training.
                      </p>
                    </div>
                  </div>

                  {/* Card 2 */}
                  <div className="col-md-6">
                    <div
                      className="p-4 info-card h-100"
                      style={{ background: "#EFEAFA" }}
                    >
                      <div className="icon-circle mb-3">
                        <img
                          src="/images/web-new-images/HomePageImage/brackthrough.svg"
                          alt="icon"
                        />
                      </div>

                      <h6 className="FS22 fw-700 to-unset-transform">
                        28–Day Breakthrough<br/> Guarantee
                      </h6>

                      <p className="FS16FW500 fw-400 mb-0" style={{color:'#383838'}}>
                        Our structured 4-week program delivers measurable
                        progress through precisely targeted practice, not
                        endless generic exercises.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        <div className="fame-wall homePage" style={{ paddingTop: "50px" }}>
          <ReusableHomePageSlider
            images={images}
            centerText={centerText}
            BottomBtns={"Visit Our Wall of Fame"}
            img="/images/web-new-images/new-dark-arrow.svg"
          />
        </div>
        <LifeAfterPassing
          data={{
            title: "Imagine Your Life",
            highlight: "After Passing",
            firstRowText:
              "The moment you receive your results,everything changes",
            points: [
              "No more explaining low scores to migration agents or university admissions officers",
              "No more postponing life plans while you attempt the exam again and again",
              "No more watching others move forward while you remain stuck",
              "No more expensive test fees for repeated attempts",
            ],
            description:
              "Instead, you'll finally move forward with your career, education, or permanent residency journey, all because you stopped trying to beat the system and learned to work with it instead.",
            ctaText: "Begin Your Journey",
            ctaAction: () => navigate("/auth/register"),
            testimonial: {
              image:
                "/images/web-new-images/new-content-slider/KiranpreetKaur.svg",
              name: "Kiranpreet Kaur",
              location: "Melbourne, Australia",
              message:
                "I'd been stuck on 50's in Speaking for over a year. I tried everything — YouTube videos, random practice tests, even a different coaching center. Nothing clicked until I found LA Language Academy. Their teachers actually showed me where my logic was breaking down, not just what score I was getting. Two months later, I hit 82. My PR application is finally moving forward.",
            },
          }}
        />
        {/* <OnlinePricingTable {...pricingData} /> */}
        <div className="container py-5">
          <div className="text-center">
            <h3 className='main-title FS40FW600 mb-0'>Three Ways To <br/> <span className='text-success FS40FW600'>Master The Exam</span></h3>
            <p className="quote-para FS18FW400 fw-500 py-4">Choose the path that works best for your goals</p>
          </div>
          <div className="row justify-content-center">

            <PricingCard
              title="PACKAGE 1"
              subtitle="Online Platform"
              price="29"
              features={[
                "AI-Powered Portal Access",
                "Complete Question Bank",
                "Scored Mock Tests",
                "Updated Templates",
                "Self-Paced Video Lessons",
              ]}
              description={'All core features, enhanced with'}
            />

            <PricingCard
              title="PACKAGE 2"
              subtitle="Online Coaching"
              price="249"
              isPopular={true}
              dark={true}
              features={[
                "Live Virtual Classes",
                "Personalized Feedback",
                "Direct Trainer Access",
                "Updated Prediction Files",
                "Priority Support",
              ]}
              description={'Everything in Online Platform, plus'}
            />

            <PricingCard
              title="PACKAGE 3"
              subtitle="Campus Coaching"
              price="249"
              features={[
                "In-Person Training",
                "One-on-one Sessions",
                "Intensive Workshops",
                "Extend Support",
                "Exam Booking Assistance",
              ]}
              description={'Everything in Platform Online Platform, plus'}
            />

          </div>
        </div>

        {/* <div className="custom-container py-5">
          <ContentImageSection
            contentSection={contentSection}
            reverse={true}
            listColumns={[
              [
                "Each failed PTE attempt: $490 AUD",
                "Delayed visa processing: Months of lost opportunity",
                "Postponed career advancement: Thousands in potential earnings",
                "Extended living expenses: $2,000+ per month while waiting",
                "Emotional stress and uncertainty: Immeasurable",
              ],
            ]}
            listSectionTitle="Consider what's really at stake"
            btnLink="/contact"
            btnClassName="mt-4"
            image={Immigration}
            imageClassName="immigration-test-img"
          />
        </div> */}
        <SkillAreas
          className={"skill-section"}
          background={"white"}
          color={"black"}
          skillAreaTitle={successRateText}
          lifestyleCards={styleSuccessCards}
          skillSubtitle={
            "Unlike programs that promise refunds, we focus on actual outcomes. Over 50,000 students achieved scores they thought were unreachable. Our track record speaks for itself."
          }
          highlitedBackground={
            `"This isn't about hoping it works, it's about following a process built on what the scoring systems actually prioritize."`
          }
        />

        <CtaBanner
          title="Take The"
          highlight="First Step Today"
          buttonText="Start Your Free Trial"
          onClick={() => { const modal = new window.bootstrap.Modal(document.getElementById('staticBackdrop')); modal.show(); }}
          rightImage="/images/web-new-images/HomePageImage/CTA-Image.webp"
        />

        <section className="decision-section py-5">
          <div className="custom-container">
            {/* Heading */}
            <div className="text-center mb-5">
              <h3 className="main-title FS40FW600 mb-0">
                You’re at a Crucial <br />
                <span className="text-success FS40FW600 tropiline">Decision Point</span>
              </h3>
              <p className="FS18FW400 mt-2" style={{color:'#0D1830'}}>
                There are really only two paths forward
              </p>
            </div>

            {/* Cards */}
            <div className="row g-4">
              {/* Card 1 */}
              <div className="col-lg-4">
                <div className="decision-card p-4 h-100">
                  <div className="step-badge green">1</div>

                  <h5 className="plus-sans FS24FW500 fw-700 mt-3">
                    Continue with traditional preparation methods
                  </h5>

                  <p className="FS16FW500 mt-3 plus-sans" style={{color:'#383838'}}>
                    Keep focusing on "improving your English" and hoping that
                    somehow your next attempt will be different. Continue
                    spending on test fees, delaying your plans, and dealing with
                    the frustration of scores that don't reflect your true
                    ability.
                  </p>
                </div>
              </div>

              {/* Card 2 */}
              <div className="col-lg-4">
                <div className="decision-card p-4 h-100">
                  <div className="step-badge purple">2</div>

                  <h5 className="plus-sans FS24FW500 fw-700 mt-3">
                    Learn how the system actually works
                  </h5>

                  <p className="FS16FW500 mt-3 plus-sans" style={{color:'#383838'}}>
                    Join Language Academy and discover what thousands of
                    successful students already know: these exams reward system
                    mastery, not just language skills. Stop guessing and start
                    following a proven process designed around the actual
                    scoring algorithms.
                  </p>
                </div>
              </div>

              {/* Card 3 (CTA) */}
              <div className="col-lg-4">
                <div className="decision-card decision-cta p-4 h-100 d-flex flex-column justify-content-between plus-sans FS18FW400 fw-500">
                  <p className="mb-4">
                    The decision is yours, but consider this: If what you've
                    been doing hasn't worked so far, why would the next attempt
                    be any different?
                  </p>

                    {/* <button className="primary-btn" onClick={() => navigate("/auth/register")}>Take Action Today  <img
                        src="/images/web-new-images/right-arrow.svg"
                        alt="Register Now"
                      />
                    </button> */}
                    <ButtonComp link={"/auth/register"} btnText={"Take Action Today"} img="/images/web-new-images/new-dark-arrow.svg"/>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Varun sir section */}

        <section className="about-section py-5 text-white">
          <div className="custom-container">
            <div className="row g-4 align-items-start gap-5">
              {/* LEFT PROFILE */}
              <div className="col-lg-4">
                <div className="profile-card">
                  <img
                    src="/images/web-new-images/HomePageImage/Founder.png"
                    alt="founder"
                    className="img-fluid rounded-4 mb-3"
                  />
                  <div className="founder-quote">
                    After scoring perfect 90's in the PTE exam multiple times, I
                    realized there was a fundamental misunderstanding about how
                    these tests work. Language Academy was built to bridge this
                    gap, helping students master the system, not just the
                    language
                  </div>
                </div>
              </div>

              {/* RIGHT CONTENT */}
              <div className="col-lg-7">
                {/* Top Heading */}
                <div className="d-flex justify-content-between align-items-center flex-wrap mb-4-5">
                  <div>
                    <h3 className="m-0 main-title FS40FW600">About</h3>
                    <h2 className="text-success FS40FW600 m-0">
                      Language Academy
                    </h2>
                  </div>

                  {/* <button className="primary-btn mt-3 mt-lg-0" onClick={() => navigate("/auth/register")}>
                    Become A Member{" "}
                    <img
                      src="/images/web-new-images/right-arrow.svg"
                      alt="Register Now"
                    />
                  </button> */}
                    <ButtonComp link={"/auth/register"} btnText={"Become A Member"} img="/images/web-new-images/new-dark-arrow.svg"/>
                </div>

                {/* Authority Card */}
                <div className="info-card p-4 mb-4-5 border-0">
                  <div className="d-flex justify-content-between align-items-start">
                    <div>
                      <div className="row">
                        <div className="col-6">
                          <div className="icon-box mb-2 d-flex">
                            <img
                              src="/images/web-new-images/HomePageImage/authority.svg"
                              alt="icon"
                            />
                          </div>
                          <span className="FS24FW500 fw-600 plus-sans">The Authority</span>
                        </div>
                        <div className="col-6 text-end">
                          <img
                            src="/images/web-new-images/HomePageImage/youtube-subscriptions.svg"
                            alt="yt"
                          />{" "}
                          <br />
                        </div>
                      </div>
                      <p className="plus-sans FS16FW500 fw-400">
                        Founded by Varun Dhawan, who has personally achieved a
                        perfect <span className="fw-700">90 score</span> in the PTE exam 14 times, Language
                        Academy has grown from a single classroom to a global
                        presence with over 10 branches across Australia, India,
                        and Nepal.
                      </p>
                    </div>
                  </div>
                </div>

                {/* Bottom Cards */}
                <div className="row g-4">
                  <div className="col-md-6">
                    <div className="info-card p-4 h-100 border-0">
                      <div className="mb-2 d-flex justify-content-start align-items-center gap-3">
                        <img
                          src="/images/web-new-images/HomePageImage/briefcase.svg"
                          alt="icon"
                        />
                        <span className="FS24FW500 fw-600">Global Presence</span>
                      </div>
                      <p className="plus-sans FS15FW400 fw-400">
                        Today, Language Academy is recognized as the leading
                        authority in algorithm-based test preparation, with our
                        methodologies helping over <span className="fw-700"> 50,000 students</span> achieve their
                        required scores for migration, education, and
                        professional advancement.
                      </p>
                    </div>
                  </div>

                  <div className="col-md-6">
                    <div className="info-card p-4 h-100 border-0">
                      <div className="mb-2 d-flex justify-content-start align-items-center gap-3">
                        <img
                          src="/images/web-new-images/HomePageImage/trend-up.svg"
                          alt="icon"
                        />
                        <span className="FS24FW500 fw-600">The Mission</span>
                      </div>
                      <p className="plus-sans FS15FW400 fw-400">
                        Highly capable English speakers repeatedly failing these
                        exams despite their language proficiency. This
                        revelation led to years of research into the underlying
                        scoring mechanics that most test-takers never discover.
                      </p>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        </section>

        {/* Tutorial images */}
        <div className="py-5 text-center">
          <TutorialVideos videos={videosData} />
        </div>

        <FaqSection questions={faqQuestions} />

        <AppBannerCustom
          appName="PTE"
          description="PTE PRACTICE"
          mobileImage="/images/web-new-images/HomePageImage/PTE-app-1.png"
          playStoreLink={`${import.meta.env.VITE_PTE_ANDROID_APP_URL}`}
          appStoreLink={`${import.meta.env.VITE_PTE_IOS_APP_URL}`}
        />
        <Footer />
      </section>
    </>
  );
};

const LifeAfterPassing = ({ data }) => {
  const {
    title,
    highlight,
    points,
    firstRowText,
    description,
    testimonial,
    ctaText,
    ctaAction,
  } = data;

  return (
    <section className="life-after-passing py-5 mt-5">
      <div className="custom-container">
        <div className="row align-items-center d-grid d-md-flex g-4 justify-content-between">
          {/* LEFT CONTENT */}
          <div className="col-12 col-lg-6">
            <h3 className="text-white top-section-text FS40FW600 mb-2">
              {title}
            </h3>
            <h3 className="text-success mb-4 FS40FW600 fw-500">{highlight}</h3>
          </div>

          {/* RIGHT CONTENT */}
          <div className="col-12 col-lg-3">
            <p className="text-white mb-3">{firstRowText}</p>

            {/* <button className="primary-btn mb-4" onClick={ctaAction}>
              {ctaText}<img
                    src={`/images/web-new-images/right-arrow.svg`}
                    alt="Register Now"
                  />
            </button> */}
             <ButtonComp link={ctaAction} btnText={ctaText} img="/images/web-new-images/new-dark-arrow.svg"/>
          </div>
        </div>
        <div className="row mt-4">
          <div className="col-lg-4">
            {/* FEATURES */}
            <div
              className="card custom-card p-4"
              style={{ background: "rgba(255, 255, 255, 0.05)" }}
            >
              <ul className="feature-list">
                {points?.map((item, i) => (
                  <li
                    key={i}
                    className="mb-2 d-flex align-items-start FS16FW500 fw-normal"
                  >
                    <p className="mb-0 text-white">{item}</p>
                  </li>
                ))}
              </ul>
            </div>
          </div>
          <div className="col-lg-8">
            <div
              className="card custom-card p-4"
              style={{ background: "rgba(255, 255, 255, 0.05)" }}
            >
              <p className="text-white mb-0">{description}</p>
            </div>
            {/* TESTIMONIAL */}
            <div
              className="card custom-card p-4"
              style={{ background: "rgba(255, 255, 255, 0.05)" }}
            >
              <div className="d-flex align-items-center mb-3">
                <img
                  src={testimonial.image}
                  alt="user"
                  className="rounded-circle me-3"
                  width="50"
                  height="50"
                />
                <div>
                  <h6 className="mb-0 text-white">{testimonial.name}</h6>
                  <small className="text-white">
                    {testimonial.location}
                  </small>
                </div>
              </div>
              <p className="text-white mb-0">{testimonial.message}</p>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const CourseSection = ({ courses = [] }) => {
  const [activeIndex, setActiveIndex] = useState(0);
  const active = courses[activeIndex];

  return (
    <section className="course-section py-5">
      <div className="custom-container">
        <div className="course-wrapper p-4 p-lg-5">
          <div className="row align-items-center justify-content-between mb-1">
            {/* LEFT SIDE */}
            <div className="col-lg-5 mb-4 mb-lg-0">
              <h3 className="FS40FW600 top-section-text m-0">{active.mainTitle}</h3>
              <h3 className="text-success mb-4 FS40FW600">
                {active.subTitle}
              </h3>
            </div>

            {/* RIGHT SIDE */}
            <div className="col-lg-4">
              <div className="row align-items-center">
                <p className="plus-sans FS18FW400 fw-500" style={{color:'#383838'}}>
                  Each program is built around the unique algorithm <br/>patterns
                  that determine success in that particular test.
                </p>
                {/* <button className="primary-btn mt-3 w-auto" onClick={() => window.location.href = '/auth/register'}>
                  Try It For Free{" "}
                  <img
                    src={`/images/web-new-images/right-arrow.svg`}
                    alt="Register Now"
                  />
                </button> */}
                <div className="w-75">
                  <ButtonComp link={"/auth/register"} btnText={"Try It For Free"} img="/images/web-new-images/new-dark-arrow.svg"/>
                </div>
              </div>
            </div>
          </div>
          <div className="row mb-0 mt-5">
            <div className="col-lg-3 mb-4 mb-lg-0">
              {/* Tabs */}
              <div className="d-flex flex-column" style={{gap:'2rem'}}>
                {courses.map((item, index) => (
                  <div
                    key={index}
                    className={`align-content-center course-tab d-flex  ${
                      index === activeIndex ? "active justify-content-between" : ""
                    }`}
                    onClick={() => setActiveIndex(index)}
                  >
                    <span className="FS20FW500 align-content-center fw-600 plus-sans">{item.tabTitle}</span>
                    {index === activeIndex && (
                      <span className="ms-2 fs-2"> {">"}</span>
                    )}
                  </div>
                ))}
              </div>
            </div>
            {/* RIGHT SIDE */}
            <div className="col-lg-9">
              <div className="row align-items-center">
                {/* Content */}
                <div className="col-md-6">
                  <div className="training-icon mb-3">
                    <img src={active.icon} alt="icon" />
                  </div>

                  <div className="FS20FW500 align-content-center fw-600 plus-sans mb-2">{active.title}</div>

                  <p className="plus-sans FS16FW500 fw-400" style={{color:'#383838'}}>{active.description}</p>

                  <button className="d-flex gap-2 mt-3 training-btn w-auto" onClick={() => window.location.href = active.ctaLink || '/auth/register'}>
                    {active.ctaText}{" "}
                    <img
                      src={`/images/web-new-images/right-arrow-green.svg`}
                      alt="Register Now"
                    />
                  </button>
                </div>

                {/* Image */}
                <div className="col-md-6 text-end mt-3 mt-md-0">
                  <img
                    src={active.image}
                    alt="course"
                    className="img-fluid course-img"
                  />
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

const StatsSection = ({ stats = [] }) => {
  return (
    <section className="stats-section py-5">
      <div className="custom-container">
        <div className="row g-4 d-grid d-lg-flex">
          {stats.map((item, index) => (
            <div className="col-12 col-lg-3" key={index}>
              <div className="stat-card position-relative h-100">
                {/* Icon */}
                <div
                  className="icon-box-hero mb-3"
                  style={{ "--state-background": `${item.color}` }}
                >
                  <img src={item.icon} alt="icon" />
                </div>

                {/* Value */}
                <span className="top-section-text FS48 fw-800">
                  {ReactHtmlParser(item.value)}
                  {/* <span style={{ color: item.color }}>+</span> */}
                </span>

                {/* Label */}
                <p className="FS20FW500 mb-0 plus-sans mt-2" style={{color:'#686868'}}>{item.label}</p>

                {/* Hover Image */}
                <img src={item.hoverImg} alt="hover" className="hover-img" />
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
};

// const CtaBanner = ({
//   title,
//   highlight,
//   buttonText,
//   onClick,
//   rightImage,
//   bgGradient = "radial-gradient(circle at center, rgba(127, 86, 217, 0.88) 0%, transparent 60%),linear-gradient(90deg, rgb(11, 15, 58), rgb(11, 15, 58))",
// }) => {
//   return (
//     <section className="cta-banner py-5">
//       <div className="custom-container">
//         <div
//           className="cta-wrapper position-relative align-content-center"
//           style={{ background: bgGradient }}
//         >
//           <div className="row align-items-center">
//             {/* LEFT CONTENT */}
//             <div className="col-lg-5 text-white p-4 p-lg-5">
//               <h2 className="top-section-text fw-600 mb-4">
//                 {title} <br />
//                 <span className="text-success fw-600">{highlight}</span>
//               </h2>

//               {/* <button className="primary-btn" onClick={onClick}>
//                 {buttonText}<img
//                     src={`/images/web-new-images/right-arrow.svg`}
//                     alt="Register Now"
//                   />
//               </button> */}
//               <ButtonComp link={onClick} btnText={buttonText} img="/images/web-new-images/new-dark-arrow.svg"/>
//             </div>

//             {/* RIGHT IMAGE */}
//             <div className="col-lg-7 text-center position-relative">
//               <img
//                 src={rightImage}
//                 alt="banner visual"
//                 className="cta-image"
//               />
//             </div>
//           </div>
//         </div>
//       </div>
//     </section>
//   );
// };

const TutorialVideos = ({ videos = [] }) => {
  const cardsRef = useRef([]);
  const [activeVideo, setActiveVideo] = useState(null);
  const [screenSize, setScreenSize] = useState("desktop");
  
  const transforms = [
    { x: -420, y: -7, rotate: -3.12, scale: 0.85,zIndex: 97 }, // 1st
    { x: -280, y: -2, rotate: 4.75, scale: 0.9,zIndex: 98 },   // 2nd
    { x: -140, y: 4, rotate: -4.58, scale: 0.95,zIndex: 99 },  // 3rd
    { x: 0, y: 0, rotate: 0, scale: 1,zIndex: 100 },        // center
    { x: 140, y: 4, rotate: 4.66, scale: 0.95,zIndex: 99 },  // 5th
    { x: 280, y: -2, rotate: -3.3, scale: 0.9,zIndex: 98 },   // 6th
    { x: 420, y: -7, rotate: 4.72, scale: 0.85,zIndex: 97 }, // 7th
  ];

  const smallDesktopTransforms = [
    { x: -110, y: -0, rotate: -6, scale: 0.9, zIndex: 99 },
    { x: 0, y: 0, rotate: 0, scale: 1, zIndex: 100 },
    { x: 110, y: 0, rotate: 6, scale: 0.9, zIndex: 99 },
  ];

  const tabletOnlyTransforms = [
    { x: 70, y: -3, rotate: -3, scale: 0.92, zIndex: 99 },
    { x: 0, y: 0, rotate: 0, scale: 1, zIndex: 100 },
    { x: -70, y: -3, rotate: 3, scale: 0.92, zIndex: 99 },
  ];

  useEffect(() => {
      const updateScreen = () => {
        if (window.innerWidth < 576) setScreenSize("mobile");
        else if (window.innerWidth < 769) setScreenSize("tablet");
        else if (window.innerWidth < 992) setScreenSize("smallDesktop");
        else setScreenSize("desktop");
      };

      updateScreen();
      window.addEventListener("resize", updateScreen);

      return () => window.removeEventListener("resize", updateScreen);
    }, []);

  useEffect(() => {
    if (videos.length === 0) return;

    // const calculatePositions = () => {
    //   const totalCards = videos.length;
    //   const cardWidth =
    //     window.innerWidth > 1400
    //       ? 280
    //       : window.innerWidth > 1200
    //         ? 240
    //         : window.innerWidth > 992
    //           ? 220
    //           : window.innerWidth > 768
    //             ? 180
    //             : 140; // 🔥 smaller for mobile
    //   const spacing =
    //     window.innerWidth < 768
    //       ? cardWidth * 0.6 // tighter spacing on mobile
    //       : cardWidth * 0.75;
    //   const maxRotation = 8; // Maximum rotation in degrees

    //   // Calculate the middle index (center card)
    //   const middleIndex = Math.floor(totalCards / 2);

    //   cardsRef.current.forEach((card, index) => {
    //     if (!card || window.innerWidth <= 768) return; // Skip on mobile

    //     // Calculate position relative to center
    //     const positionFromCenter = index - middleIndex;

    //     // Calculate translateX
    //     const translateX = positionFromCenter * spacing;

    //     // Calculate rotation (cards further from center have more rotation)
    //     const rotation = -(positionFromCenter / middleIndex) * maxRotation;

    //     // Calculate z-index (center card highest, decreasing outward)
    //     const zIndex = totalCards - Math.abs(positionFromCenter);

    //     // Apply transform
    //     card.style.setProperty(
    //       "--card-transform",
    //       `translateX(${translateX}px) rotate(${rotation}deg)`,
    //     );

    //     card.style.zIndex = zIndex;
    //     // card.style.transform = `translateX(${translateX}px) rotate(${rotation}deg)`;
    //     // card.style.zIndex = zIndex;
    //   });
    // };

    // Calculate positions on mount and window resize
    
    // const calculatePositions = () => {
    //   const totalCards = videos.length;
    //   const isMobile = window.innerWidth <= 768;

    //   const cardWidth =
    //     window.innerWidth > 1400
    //       ? 280
    //       : window.innerWidth > 1200
    //         ? 240
    //         : window.innerWidth > 992
    //           ? 220
    //           : window.innerWidth > 768
    //             ? 180
    //             : 140;

    //   const spacing = isMobile
    //     ? cardWidth * 0.6
    //     : cardWidth * 0.55; // tighter like screenshot

    //   const maxRotation = 12; // slightly stronger tilt
    //   const middleIndex = Math.floor(totalCards / 2);

    //   cardsRef.current.forEach((card, index) => {
    //     if (!card) return;

    //     const offset = index - middleIndex;
    //     const distance = Math.abs(offset);

    //     // 🔥 Non-linear curve (key change)
    //     const curveFactor = Math.pow(distance / middleIndex, 0.8);

    //     const translateX = offset * spacing;

    //     const rotation =
    //       offset === 0
    //         ? 0
    //         : (offset > 0 ? -1 : 1) * curveFactor * maxRotation;

    //     // Slight scale effect for depth
    //     const scale = 1 - distance * 0.05;

    //     const zIndex = totalCards - distance;

    //     card.style.setProperty(
    //       "--card-transform",
    //       `translateX(${translateX}px) rotate(${rotation}deg) scale(${scale})`
    //     );

    //     card.style.zIndex = zIndex;
    //   });
    // };
    // 
    // const calculatePositions = () => {
    //   cardsRef.current.forEach((card, index) => {
    //     if (!card || !transforms[index]) return;

    //     const { x, y, rotate, scale } = transforms[index];

    //     card.style.setProperty(
    //       "--card-transform",
    //       `translateX(${x}px) translateY(${y}vh)  rotate(${rotate}deg) scale(${scale})`
    //     );

    //     card.style.zIndex = 100 - Math.abs(index - 3); // center = highest
    //   });
    // };
    
    const calculatePositions = () => {
      if (screenSize === "mobile") return; // ❌ skip transforms
      let activeTransforms;

      if (screenSize === "tablet") {
        activeTransforms = tabletOnlyTransforms;
      } else if (screenSize === "smallDesktop") {
        activeTransforms = smallDesktopTransforms;
      } else {
        activeTransforms = transforms;
      }

      cardsRef.current.forEach((card, index) => {
        if (!card || !activeTransforms[index]) return;
        
        const { x, y, rotate, scale, zIndex } = activeTransforms[index];

        card.style.setProperty(
          "--card-transform",
          `translateX(${x}px) translateY(${y}vh)  rotate(${rotate}deg) scale(${scale})`
        );

        card.style.zIndex = zIndex; // center index = 1 for tablet
      });
    };
    
    calculatePositions();
    window.addEventListener("resize", calculatePositions);

    return () => window.removeEventListener("resize", calculatePositions);
  }, [videos,screenSize]);

  const handleVideoClick = (videoIndex, video) => {
    console.log("Video card clicked:", videoIndex, video);
    setActiveVideo(video);
    // Add your custom function logic here
    // Example: Open video player, navigate to video page, etc.
  };

  const handleViewAll = () => {
    window.location.href = '/video-courses';
  };

  const getYoutubeId = (url) => {
    const regExp =
      /(?:youtube\.com\/(?:shorts\/|watch\?v=)|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };

  return (
    <div className="container-fluid">
      <div className="top-section-text">
        <h3 className="hero-title FS40FW600">
          Tutorial <span className="text-success">Videos</span>
        </h3>
        <p className="FS18FW400 fw-500">
          You have powerful paths to choose from moving forward.
        </p>

        <div className="cards-container">
          {screenSize === "mobile" ? (
            <Swiper modules={[FreeMode]}
          spaceBetween={3}
          slidesPerView={1.2}
          freeMode={{
            enabled: true,
            momentum: true,
            momentumBounce: false,
          }}
          grabCursor={true}
          >
              {videos.map((video, index) => (
                <SwiperSlide key={index}>
                  <div
                    className="video-card"
                    onClick={() => handleVideoClick(index + 1, video)}
                  >
                    <img src={video.thumbnail} alt={video.title} />
                    <div className="play-btn">▶</div>
                  </div>
                </SwiperSlide>
              ))}
            </Swiper>
          ) : (
            (
              screenSize === "tablet" || screenSize === "smallDesktop"
                ? videos.slice(2, 5)
                : videos
            ).map(
              (video, index) => (
                <div
                  key={index}
                  ref={(el) => (cardsRef.current[index] = el)}
                  className="video-card"
                  onClick={() => handleVideoClick(index + 1, video)}
                >
                  <img src={video.thumbnail} alt={video.title} />
                  <div className="play-btn">▶</div>
                </div>
              )
            )
          )}
        </div>

        {/* <div className="cards-container d-none">  custom-container
          {videos.map((video, index) => (
            <div
              key={index}
              ref={(el) => (cardsRef.current[index] = el)}
              className="video-card"
              onClick={() => handleVideoClick(index + 1, video)}
            >
              <img src={video.thumbnail} alt={video.title} />
               <div className="play-btn">▶</div>
            </div>
          ))}
        </div> */}
          {/* <VideoSlider videos={videos} /> */}

        <ButtonComp className={"mx-auto"} link={handleViewAll} btnText={"View All Videos"} img="/images/web-new-images/new-dark-arrow.svg"/>

        {activeVideo && activeVideo.type === "youtube" && (
          <YoutubeVideoPlayer
            isOpen={true}
            toggle={() => setActiveVideo(null)}
            videoUrl={`https://www.youtube.com/embed/${getYoutubeId(
              activeVideo.url
            )}?autoplay=1`}
          />
        )}
      </div>
    </div>
  );
};


const VideoSlider = ({ videos }) => {
  const [activeVideo, setActiveVideo] = useState(null);

  const getYoutubeId = (url) => {
    const regExp =
      /(?:youtube\.com\/(?:shorts\/|watch\?v=)|youtu\.be\/)([^&?/]+)/;
    const match = url.match(regExp);
    return match ? match[1] : "";
  };

  const getYoutubeThumbnail = (url) => {
    const id = getYoutubeId(url);
    return `https://img.youtube.com/vi/${id}/hqdefault.jpg`;
  };

  return (
    <>
      {/* SLIDER */}
      <div className="hero-slider reels-section mt-5 d-flex overflow-auto gap-3">
        {/* {videos.map((video, index) => (
          <div className="hero-card hero-card-home" key={index}>
            <div
              className="video-thumbnail position-relative cursor-pointer"
              onClick={() => setActiveVideo(video)}
            >
              <img
                src={video.thumbnail ? video.thumbnail : getYoutubeThumbnail(video.url)}
                alt="video"
                className="img-fluid rounded-4"
                loading="lazy"
              />

              <div className="play-btn">▶</div>
            </div>
          </div>
        ))} */}
        <Swiper
          modules={[FreeMode]}
          spaceBetween={3}
          slidesPerView={1.2}
          freeMode={{
            enabled: true,
            momentum: true,
            momentumBounce: false,
          }}
          grabCursor={true}
          breakpoints={{
             0: { slidesPerView: 1.2 },     // ✅ mobile fix
            576: { slidesPerView: 1.8 },
            768: { slidesPerView: 2.8 },
            850: { slidesPerView: 3 },
            1200: { slidesPerView: 3.8 },
            1440: { slidesPerView: 4.1 },
            1800: { slidesPerView: 4.8 },
          }}
        >
          {videos.map((video, index) => (
            <SwiperSlide key={index}>
              <div className="hero-card hero-card-tutorial">
                <div
                  className="video-thumbnail position-relative cursor-pointer"
                  onClick={() => setActiveVideo(video)}
                >
                  <img
                    src={video.thumbnail ? video.thumbnail : getYoutubeThumbnail(video.url)}
                    alt="video"
                    className="img-fluid rounded-4"
                    loading="lazy"
                  />

                  <div className="play-btn">▶</div>
                </div>
              </div>
            </SwiperSlide>
          ))}
        </Swiper>
      </div>

      {/* POPUP (ONLY ONE) */}
      {activeVideo && activeVideo.type === "youtube" && (
        <YoutubeVideoPlayer
          isOpen={true}
          toggle={() => setActiveVideo(null)}
          videoUrl={`https://www.youtube.com/embed/${getYoutubeId(
            activeVideo.url
          )}?autoplay=1`}
        />
      )}
    </>
  );
};

export const PricingCard = ({
  title,
  subtitle,
  price,
  isFree = false,
  currency = "AUD",
  features = [],
  isPopular = false,
  dark = false,
  description = '',
  ctaLink = "/auth/register",
  btaBtnText="Start Your Plan",
  onDownloadClick,
  img
}) => {
  return (
    <div className="col-lg-4 col-md-6 mb-4 d-flex">
      <div
        className={`pricing-card-new w-100 ${
          dark ? "pricing-card-dark" : ""
        }`}
      >
        {/* Popular Badge */}
        {isPopular && (
          <div className="popular-badge FS16FW500 fw-400">MOST POPULAR</div>
        )}

        <span className="package-label FS16FW500 fw-400 mb-2">{title}</span>

        <span className="fw-600 FS24FW500">{subtitle}</span>
        <p className={`${isPopular ? 'text-white' : 'text-gray-pricing'} mb-4`}>
          {description}
        </p>
        <span className="FS14FW600 plus-sans" style={{color: isPopular ? '#D0D0D0' : '#686868'}}>{isFree ? " " : "Starting From"}</span>
        <span className="top-section-text FS40FW600 fw-800">
          {isFree ? "" : "$"}{price} <span className="plus-sans FS14FW600" style={{color: isPopular ? '#D0D0D0' : '#686868'}}>{currency}</span>
        </span>

        {/* <ul className="feature-list-price-new">
          {features.map((item, i) => (
            <li key={i} style={{ color: isPopular ? '#D0D0D0' : '#686868' }} className="FS16FW500">
              {item}
            </li>
          ))}
        </ul> */}
        <ul className="feature-list-price-new">
          {features.map((item, i) => {
            const isActive = typeof item === "object" ? item.active : true;
            const text = typeof item === "object" ? item.text : item;

            return (
              <li
                key={i}
                className={`FS16FW500 ${isActive ? "feature-active" : "feature-inactive"}`}
                style={{ color: isPopular ? "#D0D0D0" : "#686868" }}
              >
                {text}
              </li>
            );
          })}
        </ul>

        <button className={`card-btn plus-sans FS17FW500 fw-700 to-unset-transform w-100 ${isPopular ? "primary-btn" : "cta-btn"}`} 
        onClick={() => { 
    if (isFree && onDownloadClick) {
      onDownloadClick();
    } else {
      window.location.href = ctaLink;
    }
  }}
        >
          {isFree ? "Download Now" : btaBtnText}{" "}
          <img
            src={img || `/images/web-new-images/${isPopular ? "new-dark-arrow.svg" : "right-arrow-black.svg"}`}
            alt="Register Now"
          />
        </button>
      </div>
    </div>
  );
};

export default Home;
